export const onlyAlphanumericAndSpaces = new RegExp(/^[\p{L}0-9 ]+$/u);

export const onlyUppercaseAlphanumeric = /^[A-Z0-9]+$/;

export const argentinianPlate = /^([A-Z]{3}\d{3}|[A-Z]{2}\d{3}[A-Z]{2})$/;

export const onlyLetters = new RegExp(/^[\p{L} ]+$/u);

export const onlyLettersNoSpaces = new RegExp(/^(?! )\p{L}+(?: \p{L}+)*$/u);

export const onlyNumbers = new RegExp(/^\d+$/);

// Allows single-character digits or decimal dot on keypress filtering
export const numbersWithDecimal = new RegExp(/^[0-9.]$/);

// Allows single-character digits or comma (,) for locales using comma decimal separator
export const numbersWithCommaDecimal = new RegExp(/^[0-9,]$/);

export const isEmail = new RegExp(/^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/);
